var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kakao-callback-container"},[_c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"spinner"}),_c('p',{staticClass:"loading-text"},[_vm._v("카카오 로그인 처리 중입니다...")]),_c('p',{staticClass:"sub-text"},[_vm._v("잠시만 기다려주세요.")])])])
}]

export { render, staticRenderFns }